import React from "react";
import styled from "styled-components";
import RevenueBanner from "../../Images/RevenueBanner.png";
import BannerRevenue from "./BannerRevenue";
import DetailsFilter from "./DetailsFilter";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";

const Root = styled.div`
 background-image: url(${RightBackgroundImage});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
const Container = styled.div``;

const Revenuestreams = () => {
  return (
    <Root>
      <Container>
        <BannerRevenue />
        <DetailsFilter />
      </Container>
    </Root>
  );
};

export default Revenuestreams;
